var __defProp = Object.defineProperty;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp.call(b, prop))
      __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(b)) {
      if (__propIsEnum.call(b, prop))
        __defNormalProp(a, prop, b[prop]);
    }
  return a;
};
import { newGuid } from "../services/GuidHelper.js";
import logger, { ErrorType } from "../services/logging/Logger.js";
function onError(options = {}) {
  let defaultOptions = {
    message: "Sorry, an error has occurred.",
    _onError_useOnlyForIntneralOrUnitTest: (error, onErrorOptions, propertyKey) => {
      let errorMessage = error.message || onErrorOptions.message;
      let errorStack = error.stack;
      logger.error(error, ErrorType.OnErrorDecorator, {
        errorCorrelationId: error.errorCorrelationId,
        errorStack,
        onErrorDecoratorTarget: propertyKey,
        onErrorDecoratorUserMessage: onErrorOptions.message,
        rethrowException: !!onErrorOptions.throwExceptions,
        // these props may exisit from RestServiceBase.ensureSuccess()
        innerError: error.innerError,
        correlationId: error.correlationId,
        isAborted: error.isAborted,
        suppressPopup: true
      });
    },
    throwExceptions: true,
    // @ts-ignore
    defaultResult: void 0
  };
  return function(target, propertyKey, descriptor) {
    const originalFunction = descriptor.value;
    const effectiveOptions = __spreadValues(__spreadValues({}, defaultOptions), options);
    descriptor.value = function(...args) {
      try {
        let result = originalFunction.apply(this, args);
        if (!!result && typeof result.then === "function") {
          result = result.catch((e) => handleError(e, effectiveOptions, propertyKey));
        }
        return result;
      } catch (e) {
        return handleError(e, effectiveOptions);
      }
    };
  };
  function handleError(e, options2, propertyKey) {
    let rethrow = e;
    if (typeof e == "string") {
      rethrow = Error(e);
      rethrow.stack = "no stack: throwing plain string exceptions do not have a proper stack, throw Error() instead";
    }
    rethrow.errorCorrelationId = rethrow.errorCorrelationId || newGuid();
    options2._onError_useOnlyForIntneralOrUnitTest(cleanupError(rethrow), options2, propertyKey);
    if (!!options2.throwExceptions) {
      throw rethrow;
    }
    return options2.defaultResult;
  }
  function cleanupError(e) {
    let result = e;
    if (result.innerMessage) {
      result = __spreadValues({ CorrelationId: result.correlationId }, result.innerMessage);
    }
    return result;
  }
}
export {
  onError
};
//# sourceMappingURL=OnError.js.map
